import React, { Component } from 'react';

export default class TabButton extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.handleClick(this.props.index);
    }

    render() {
        return (
            <button type="button" role="tab" aria-selected={this.props.isActive}
                    aria-controls={"tabcontent-id-" + this.props.index} id={"tab-button-id-" + this.props.index}
                    className={"tabs-component__button-item " + (this.props.isActive ? "active" : "")}
                    onClick={this.handleClick}>
                {this.props.text}
            </button>
        );
    }
}